import { IResourceArrInfo } from './resourceStore';
import { ISectionBaseInfo } from './sectionInfo';
import { ISectionOptionBaseExtendInfo, ISectionOptionBaseInfo } from './sectionOptionInfo';

import { MediaType, ESectionType, QUIZ_ANSWER_LEVEL, SCORE_TYPE } from '../enums';

export type IQestionId = number;
export type IQestionOptionId = string;

export interface IQuizUserValue {
    user_answer_id: IQestionOptionId;
    user_answer_content?: string;
    user_answer_pic?: string[];
    resource_arr?: IResourceArrInfo[];
}

export interface IQuizAnswer {
    right_answer_id?: IQestionOptionId;
    right_answer_content?: string;
}

/**
 * 问题的 setup 可能的数据结构
 */
export interface IQuizSectionSetup {
    score: number;
    partial_score?: number;
    level: number;
    require?: string; // 是否必填 0：否；1：是，考试都是0
    screenOrderType?: string;
}

export interface IQuizQuestionExplain {
    desc: string;
    media_type?: MediaType;
    media_url?: string[];
}

export interface IQuizExtend extends ISectionOptionBaseExtendInfo {
    setup: IQuizSectionSetup;
    media_type?: MediaType;
    media_url?: string[];
    question_explain?: IQuizQuestionExplain;
}

/**
 * 端上增加的数据结构，也是端上表单组件使用的数据结构
 */
export interface IQuizSectionInfo extends ISectionBaseInfo<ESectionType, ISectionOptionBaseInfo, IQuizExtend> {
    sectionIndex?: number;
    schemeIndex?: number; // 题号颜色 1 - 9
    // 通过 quizService 的 getUserQuizResult 生成，再合并到 sectionInfo
    userValue?: IQestionOptionId[]; // 单人结果
    // 通过 quizService 的 getQuizAnswerResult 生成，再合并到 sectionInfo
    rightAnswer?: IQestionOptionId[]; // 正确答案answer id
    rightAnswerValue?: string[]; // 正确答案 填空题答案
    // TODO: 结果展示需要的数据是否完善
    // 用户答题数据的扩展数据
    userValueExtend?: IUserValueExtend;
    score_type?: SCORE_TYPE;
}

export interface IUserValueExtend {
    user_answer_pic?: string[];
    user_answer_analysis?: string;
    user_answer_status?: number; // 打分状态
    user_answer_score?: number;
    user_answer_level?: QUIZ_ANSWER_LEVEL;
    user_answer_score_type?: SCORE_TYPE;
}

/**
 * 服务端返回的单人结果 - map
 */
export interface IServerUserQuizResultMap {
    [key: string]: IQuizSectionUserResult[];
}

export enum E_QUIZ_ANSWER_RIGHT {
    WRONG = 0,
    RIGHT = 1,
    PARTIAL = 2
}

/**
 * 提交接口用的问题组件的最终结果
 */
export interface IQuizSectionUserResult {
    user_answer_id?: IQestionOptionId;
    user_answer_content?: string;
    user_answer_content_mark?: number; // 错题本中练习时提交的 EIsSubmitQuestionRight
    user_answer_pic?: string[];
    user_answer_analysis?: string;
    user_answer_status?: number;
    user_answer_score?: number;
    user_answer_score_type?: SCORE_TYPE;
}

/**
 * 服务端返回的问题答案 - map
 */
export interface IServerQuizAnswerMap {
    [key: string]: IQuizSectionAnswer[];
}

/**
 * 问题答案
 */
export interface IQuizSectionAnswer {
    right_answer_id?: IQestionOptionId;
    right_answer_content?: string;
}
